// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"266":"b7fa17ca","453":"60342b00"}[chunkId] + ".chunk.js";
};